export const colors = {
  primary: "#39207C",
  purpleCream: "#F1F0FF",
  creamPink: "#FBF6F1",
  deepPurple: "#271551",
  royalPurple: "#4D22B1",
  lightPurple: "#F9F9FF",
  lightPurple2: "#F2EAFF",
  black: "#0A0021",
  nearBlack: "#030029",
  nearBlack2: "#00203E",
  gray: "#858BA6",
  gray2: "#5D5F60",
  gray3: "#F4F8F5",
  lightGray: "#F6F6F6",
  mediumGray: "#d4d4d4",
  disabledGray: "#C0C0CF",
  disabledBg: "#D5D5DA",
  darkGray: "#5C6177",
  deepBlue: "#030212",
  blurple: "#4441d9",
  dimmedBlurple: "rgba(68, 65, 217, 0.5)",
  peach: "#FFC1AD",
  lightPeach: "#FFEFEB",
  violet: "#18184A",
  darkViolet: "#39003E",
  red: "#D94141",
  alertRed: "#FF0000",
  yellow: "#FFE600",
  yellow2: "#FFDB00",
  highlightYellow: "#FFF7AD",
  green: "#8AD54F",
  green2: "#3C9737",
  green3: "#00A66E",
  greenBadgeBg: "#C8FFEA40",
  greenBadgeText: "#124A38",
  amber: "#9D5B29",
  amberLight: "rgba(157, 91, 41, 0.05)",
  amberText: "#A15D28",
  darkText: "#140C2D",
  subtitleGray: "#545454",
  verifiedGreen: "#165F47",
  white: "#FFFFFF",
  shamrock: "#2CBBB2",
  windsor: "#6E0E8E",
  yellowOrange: "#FEB23E",
  disclaimer: "#828F9B",
  lightBlue: "#F2F1FF",
  primaryBlue: "#5549FF",
  blue: "#4B3DFA",
  blueGradient:
    "linear-gradient(0deg, rgba(14, 10, 44, 0.15) 0%, rgba(14, 10, 44, 0.15) 100%), linear-gradient(340deg, #9CC8F4 -9.41%, #3E2B84 101.5%)",
};

// Define a custom blurple color using MantineColorsTuple
export const blurple: [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
] = [
  "#EBF2FF", // lightest
  "#D0D9FF",
  "#A3B3FF",
  "#738CFF",
  "#4A65FF",
  "#4441D9", // main color --blurple
  "#2C46E6",
  "#2337B3",
  "#141E6E",
  "#0D154A", // darkest
];
